import { setMouseflowVariable } from "@/shared/lib/mouseflow/script";
import { ANALYTICS_PROVIDER } from "../models";
import type {
  MouseflowDqErrorTag,
  MouseflowEvent,
  MouseflowFormSubmit,
  MouseflowVariable,
} from "../models";
import { handleAnalyticsError } from "../utils";

interface MouseflowTrackingParams {
  event: MouseflowEvent | MouseflowDqErrorTag;
}

export const triggerMouseflowTracking = ({
  event,
}: MouseflowTrackingParams) => {
  try {
    window._mfq = window._mfq ?? [];
    window._mfq.push(["tag", event]);
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error tracking Mouseflow event",
      provider: ANALYTICS_PROVIDER.MOUSEFLOW,
      extra: {
        event,
      },
    });
  }
};

interface MouseflowVariableParams {
  variable: MouseflowVariable;
  value: string;
}

export const setMouseflowSessionVariable = ({
  variable,
  value,
}: MouseflowVariableParams) => {
  setMouseflowVariable(window, variable, value);
};

interface MouseflowFormSubmitParams {
  submit: MouseflowFormSubmit;
  formId: string;
}

export const triggerMouseflowFormSubmit = ({
  submit,
  formId,
}: MouseflowFormSubmitParams) => {
  try {
    window._mfq = window._mfq ?? [];
    window._mfq.push([submit, `#${formId}`]);
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error tracking Mouseflow form submit",
      provider: ANALYTICS_PROVIDER.MOUSEFLOW,
      extra: {
        submit,
        formId,
      },
    });
  }
};
